<button
  [matTooltip]="isFavorite ? 'Unfavourite' : 'Favourite'"
  [matTooltipDisabled]="disableTooltip"
  mat-icon-button
  [ngClass]="{ gold: isFavorite, 'favorite-btn': true }"
  (click)="onFavoriteClicked($event)"
>
  <mat-icon>star</mat-icon>
</button>
